var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTailMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21967 14.2197C9.51256 13.9268 9.98744 13.9268 10.2803 14.2197L12 15.9393L13.7197 14.2197C14.0126 13.9268 14.4874 13.9268 14.7803 14.2197C15.0732 14.5126 15.0732 14.9874 14.7803 15.2803L12.5303 17.5303C12.2374 17.8232 11.7626 17.8232 11.4697 17.5303L9.21967 15.2803C8.92678 14.9874 8.92678 14.5126 9.21967 14.2197Z",
    fill: "#171717",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7803 9.78033C14.4874 10.0732 14.0126 10.0732 13.7197 9.78033L12 8.06066L10.2803 9.78033C9.98744 10.0732 9.51256 10.0732 9.21967 9.78033C8.92678 9.48744 8.92678 9.01256 9.21967 8.71967L11.4697 6.46967C11.7626 6.17678 12.2374 6.17678 12.5303 6.46967L14.7803 8.71967C15.0732 9.01256 15.0732 9.48744 14.7803 9.78033Z",
    fill: "#171717",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTailMove);
export default __webpack_public_path__ + "static/media/arrow_tail_move.b849479150d96103fdd83f8e5aab0a41.svg";
export { ForwardRef as ReactComponent };